import { createContext } from 'react';
import useAuthentication from 'src/store/hooks/useAuthentication';

const AdminAuthContext = createContext({
  token: '',
  account: undefined,
  isLoggedIn: false,
  isAdmin: false,
  isSuperUser: false,
  logoutNotified: false,
  login: () => {},
  logout: () => {},
  clearAccessToken: () => {},
});

export const AdminAuthProvider = (props) => {
  const { initialized, loginState, logoutHandler, loginHandler, clearAccessToken, refreshSession } =
    useAuthentication({
      logoutEndpoint: '/admin/logout',
      accessTokenEndpoint: '/admin/accessToken',
    });

  const contextValue = {
    token: loginState.token,
    account: loginState.account,
    isLoggedIn: !!loginState.token,
    logoutNotified: loginState.logoutNotified,
    login: loginHandler,
    logout: logoutHandler,
    isAdmin: loginState?.account?.isAdmin,
    clearAccessToken,
    refreshSession,
    remainingTime: loginState?.remainingTime,
  };
  return initialized ? (
    <AdminAuthContext.Provider value={contextValue}>{props.children}</AdminAuthContext.Provider>
  ) : null;
};

export default AdminAuthContext;
